import { render } from "./ShimmerText.vue?vue&type=template&id=2f6ba6b6&scoped=true"
import script from "./ShimmerText.vue?vue&type=script&lang=js"
export * from "./ShimmerText.vue?vue&type=script&lang=js"

import "./ShimmerText.vue?vue&type=style&index=0&id=2f6ba6b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6ba6b6"]])

export default __exports__